export const getUrlExtension = (_url: string) => {
    try {
        const url = new URL(_url);
        const ext = url.pathname.split(".")[url.pathname.split(".").length - 1];
        return ext;
    } catch (err) {
        return "";
    }
};